import { useQuery } from '@apollo/client/react';

import { IRole, CurrentUserDocument } from 'graphql/types';

export const useOfferPermissions = () => {
    const { data: currentUserData } = useQuery(CurrentUserDocument);

    const currentUser = currentUserData?.currentUser;

    const currentUserIsManager = currentUser?.roles?.includes(IRole.Manager);
    const currentUserIsAuthor = currentUser?.roles?.includes(IRole.Author);

    return {
        currentUserIsManager,
        currentUserIsAuthor,
        currentUser,
    };
};
